module.exports = __webpack_public_path__ + "img/osszes-kategoria-icon.3dc68e78.svg";